'use client'

import React from 'react'
import { I18nProvider } from 'fuse_common/components/ui/i18n-provider'
import { RootPortalNesting } from 'fuse_common/components/dom/root-portal'
import { usePathname } from 'next/navigation'
import { AppDownloadFloater } from '@/components/landing/components/navigation/app-download-floater'

const showDownloadAppFloaterOn = ['/component-library', '/legal', '/support', '/app', '/quote']

export const RootContextProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const pathname = usePathname()

  const showDownloadAppFloater = React.useMemo(() => {
    if (pathname === '/') {
      return false
    }

    if (process.env.NODE_ENV !== 'development' && process.env.NEXT_PUBLIC_ENVIRONMENT !== 'test') {
      return false
    }

    return showDownloadAppFloaterOn.some((path) => pathname.startsWith(path))
  }, [pathname])

  return (
    <>
      <I18nProvider common landing blog>
        {showDownloadAppFloater && <AppDownloadFloater />}
        {children}
        <RootPortalNesting />
      </I18nProvider>
    </>
  )
}
